import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import DiscountIcon from "../../assets/discoutCircle.svg";
import CardPos from "../../assets/cardPos.svg";
import headPhone from "../../assets/earPhone.svg";
import Cash from "../../assets/cash.svg";
import Secure from "../../assets/secure.svg";
import Person from "../../assets/person.svg";
import Activity from "../../assets/activity.svg";
import Advice from "../../assets/advice.svg";
import "./vipCard.css";

const VipCard = () => {
  useEffect(() => {
    AOS.init({ duration: 1500, once: true });
  }, []);
  return (
    <div className="cardContainer" data-aos="fade-up">
      <div className="cardSubContainer">
        <div className="discountContainer">
          <div className="discount">
            <div className="discountImage">
              <img src={DiscountIcon} alt="" />
            </div>
            {/* <p className="discountText">Up to 6% Trading Rebate</p> */}
            <p className="discountText">VIP cashback up to 6%</p>
          </div>
          <div className="discount">
            <div className="discountImage">
              <img src={CardPos} alt="" />
            </div>
            <p className="discountText">Fast Withdrawals</p>
          </div>
          <div className="discount">
            <div className="discountImage">
              <img src={headPhone} alt="" />
            </div>
            <p className="discountText">VIP Customer Service</p>
          </div>
          <div className="discount">
            <div className="discountImage">
              <img src={Cash} alt="" />
            </div>
            <p className="discountText">Exclusive Rewards</p>
          </div>
        </div>

        <div className="discountContainer">
          <div className="discount">
            <div className="discountImage">
              <img src={Secure} alt="" />
            </div>
            <p className="discountText">Secure Transactions</p>
          </div>
          <div className="discount">
            <div className="discountImage">
              <img src={Person} alt="" />
            </div>
            <p className="discountText">Dedicated Account Manager</p>
          </div>
          <div className="discount">
            <div className="discountImage">
              <img src={Activity} alt="" />
            </div>
            <p className="discountText">Priority Processing</p>
          </div>
          <div className="discount">
            <div className="discountImage">
              <img src={Advice} alt="" />
            </div>
            <p className="discountText">Customized Trading Advice</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VipCard;
